import { useMutation, useQueryClient } from "@tanstack/react-query";
import { NotifyService } from "../../../services/notify/notify-service";

export const useUpdateNotify = () => {
  const queryClient = useQueryClient();
  const { mutate } = useMutation({
    mutationFn: ({ id, fields }: { id: string; fields: any }) => {
      return NotifyService.updateNoitfy(id, fields);
    },
  });

  const updateNotify = (body: any, options?: { onSuccess?: (res: any) => void }) => {
    mutate(body, {
      onSuccess(response: any) {
        queryClient.invalidateQueries({ queryKey: ["notify"] });
        if (options?.onSuccess) options.onSuccess(response);
      },
    });
  };

  return { updateNotify };
};
